import type { CampaignRow } from './api';

// Chip de status (estilo s-chip do mockup 9-campanhas.html). Só ramps de cor
// realmente mapeados no tailwind.config (success/warning/danger/brand/n).
export const STATUS_CHIP: Record<
  CampaignRow['status'] | 'draft',
  { label: string; classes: string }
> = {
  draft: { label: 'Rascunho', classes: 'bg-n-100 text-n-700' },
  scheduled: { label: 'Agendada', classes: 'bg-warning-50 text-warning-700' },
  running: { label: 'Processando', classes: 'bg-brand-50 text-brand-700' },
  paused: { label: 'Pausada', classes: 'bg-n-100 text-n-700' },
  completed: { label: 'Concluída', classes: 'bg-success-50 text-success-700' },
  errored: { label: 'Cancelada/Erro', classes: 'bg-danger-50 text-danger-600' },
};

export function StatusChip({ status }: { status: CampaignRow['status'] | 'draft' }) {
  const s = STATUS_CHIP[status];
  return (
    <span
      className={`inline-flex items-center rounded-pill px-2 py-[2px] font-bold text-[10px] uppercase tracking-[.04em] ${s.classes}`}
    >
      {s.label}
    </span>
  );
}

export function num(n: number): string {
  return n.toLocaleString('pt-BR');
}

export function fmtDateTime(iso: string | null): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}
